// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Twitter: React.FC = () => {
    return <svg width="25" height="21" xmlns="http://www.w3.org/2000/svg" fill="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false"><path d="M7.868 20.777c9.423 0 14.578-7.804 14.578-14.578 0-.222 0-.444-.016-.666 1-.73 1.872-1.634 2.57-2.649-.92.397-1.92.682-2.95.793A5.11 5.11 0 0024.301.854 10.087 10.087 0 0121.05 2.09 5.112 5.112 0 0017.306.473c-2.84 0-5.123 2.3-5.123 5.124 0 .396.047.793.127 1.173A14.564 14.564 0 011.745 1.41a5.085 5.085 0 00-.698 2.585A5.12 5.12 0 003.33 8.261a5.16 5.16 0 01-2.316-.65v.064c0 2.49 1.761 4.552 4.109 5.028a5.418 5.418 0 01-1.349.175c-.333 0-.65-.032-.967-.08a5.133 5.133 0 004.79 3.554 10.262 10.262 0 01-6.36 2.189c-.429 0-.826-.016-1.238-.064a14.48 14.48 0 007.868 2.3z" fillRule="nonzero"/></svg>;
};

export default React.memo(Twitter);
